// First-run gate (COMMERCE_ONBOARDING_PHASE1 · Task A). Wraps the "/" landing:
// a brand-new, un-dismissed workspace (tracking status configured:false) is sent
// once to /Welcome; everyone else lands straight on the Dashboard. Only the empty
// home is gated — deep links are never redirected. The gate never blocks the
// dashboard on a status read (fails open).

import React from "react";
import { withRouter } from "react-router";
import { DashboardViewComponent } from "../dashboard";
import { getOnboardingStatus, isOnboardingDismissed } from "../../functions/onboarding-status";
class HomeGate extends React.Component {
  constructor(props) {
    super(props);
    this._alive = true;
  }
  async componentDidMount() {
    try {
      const s = await getOnboardingStatus();
      if (!this._alive) return;
      if (s && s.configured === false && !isOnboardingDismissed()) {
        this.props.history.replace("/Welcome");
      }
    } catch (e) {/* never block the dashboard on the gate */}
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    return /*#__PURE__*/React.createElement(DashboardViewComponent, {
      params: this.props.match && this.props.match.params || {}
    });
  }
}
export default withRouter(HomeGate);